import React from 'react';
import { motion } from 'framer-motion';
export function Philosophy() {
  const stops = ['Stop wasting money.', 'Stop switching tabs.', 'Stop relying on gut feeling.', 'Stop reacting too late.', 'Stop missing opportunities.'];
  return <section className="py-32 bg-secondary/30 border-y border-white/5" data-id="element-267">
      <div className="max-w-7xl mx-auto px-6" data-id="element-268">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-bold text-center mb-20 max-w-4xl mx-auto leading-tight" data-id="element-269">
          The most profitable businesses know when to stop.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-32" data-id="element-270">
          {stops.map((stop, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-card border border-white/5 rounded-2xl p-6 text-center flex items-center justify-center min-h-[120px]" data-id="element-271">
              <span className="text-textSecondary font-medium" data-id="element-272">{stop}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-273">
          <div className="inline-block glass-panel px-12 py-8 rounded-3xl accent-glow" data-id="element-274">
            <p className="text-2xl md:text-4xl font-medium text-gradient italic" data-id="element-275">
              "The data already knows what to do."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}